<nz-card class="card-inner-collpase" [nzBordered]="false" [nzActions]="getActions()">
  <nz-card-meta [nzDescription]="descriptionTemplate"></nz-card-meta>
</nz-card>

<ng-template #descriptionTemplate>
  <div *ngIf="identity.status == 'APPROVED'">
    <app-activate-identity [identity]="identity"> </app-activate-identity>
  </div>
  <div *ngIf="identity.status != 'CREATED' && identity.status != 'APPROVED' && identity.status != 'ISSUING'">
    <p>Rilasciato da: {{identity?.issuer}}</p>
    <p>Rilasciato a: {{user.first_name}} {{user.last_name}}</p>
    <p>Valido fino al: {{identity?.expire_date | date:'dd/MM/YYYY'}}</p>
  </div>
</ng-template>


<ng-template #extraTemplate>
  <i nz-icon nzType="user"></i>
</ng-template>

<ng-template #actionIdentity>
  <i nz-icon nzTooltipTitle="Gestione identità" nzTooltipPlacement="top" nz-tooltip nzType="user" nzTheme="outline"
    (click)="chooseAction('editIdentity',$event)"></i>
</ng-template>
<ng-template #actionUserCredentials>
  <i nz-icon nzTooltipTitle="Gestione credenziali" nzTooltipPlacement="top" nz-tooltip nzType="key" nzTheme="outline"
    (click)="chooseAction('editCredentials',$event)"></i>
</ng-template>
<ng-template #actionSuspend>
  <i nz-icon nzTooltipTitle="Sospendi identità" nzTooltipPlacement="top" nz-tooltip nzType="stop" nzTheme="outline"
    (click)="chooseAction('suspendIdentity',$event)"></i>
</ng-template>
<ng-template #actionResume>
  <i nz-icon nzTooltipTitle="Riattiva identità" nzTooltipPlacement="top" nz-tooltip nzType="play-circle"
    nzTheme="outline" (click)="chooseAction('resumeIdentity',$event)"></i>
</ng-template>
<ng-template #actionRevoke>
  <i nz-icon nzTooltipTitle="Revoca identità" nzTooltipPlacement="top" nz-tooltip nzType="close" nzTheme="outline"
    (click)="chooseAction('revokeIdentity',$event)"></i>
</ng-template>
<!-- <ng-template #actionActive>
  <i nz-icon nzTooltipTitle="Riattiva identità" nzTooltipPlacement="top" nz-tooltip nzType="play-circle"
    nzTheme="outline" (click)="chooseAction('revokeIdentity',$event)"></i>
</ng-template> -->
<ng-template #actionLogs>
  <i nz-icon nzTooltipTitle="Ultimi accessi" nzTooltipPlacement="top" nz-tooltip nzType="unordered-list"
    nzTheme="outline" (click)="chooseAction('accessLogs',$event)"></i>
</ng-template>